if (!customElements.get("m-itt-slider")) {
  class MIttSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.sliderContainer = this.querySelector(".swiper-container");
      if (!this.sliderContainer) return;

      this.total = parseInt(this.dataset.total, 10) || 0;
      this.perView = parseInt(this.dataset.perView, 10) || 3;
      this.perViewTablet = parseInt(this.dataset.perViewTablet, 10) || 2;
      this.perViewMobile = parseInt(this.dataset.perViewMobile, 10) || 1;
      this.autoplay = this.dataset.autoplay === "true";
      this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed, 10) || 5;

      this.initSlider();
    }

    disconnectedCallback() {
      if (this.slider && typeof this.slider.destroy === "function") {
        this.slider.destroy(true, true);
        this.slider = null;
      }
    }

    initSlider() {
      // Looping with as many (or fewer) slides than are visible duplicates or
      // blanks out slides in Swiper, so only enable it when there is overflow.
      const canLoop = this.total > this.perView;

      this.slider = new DeliLibs.Swiper(this.sliderContainer, {
        slidesPerView: this.perViewMobile,
        spaceBetween: 16,
        loop: canLoop,
        speed: 400,
        watchOverflow: true,
        autoplay:
          this.autoplay && canLoop
            ? {
                delay: this.autoplaySpeed * 1000,
                disableOnInteraction: true,
              }
            : false,
        pagination: {
          el: this.querySelector(".swiper-pagination"),
          clickable: true,
          bulletClass: "m-dot",
          bulletActiveClass: "m-dot--active",
        },
        navigation: {
          nextEl: this.querySelector(".m-itt__nav--next"),
          prevEl: this.querySelector(".m-itt__nav--prev"),
        },
        breakpoints: {
          // Tablets and small laptops keep the tablet count so cards never
          // get squeezed below a readable width.
          768: {
            slidesPerView: Math.min(this.perViewTablet, this.total),
          },
          1280: {
            slidesPerView: Math.min(this.perView, this.total),
          },
        },
      });
    }
  }

  customElements.define("m-itt-slider", MIttSlider);
}
